import { render } from "./TemplateBookBookingPaymentSelection.vue?vue&type=template&id=f37b1108&scoped=true"
import script from "./TemplateBookBookingPaymentSelection.vue?vue&type=script&lang=js"
export * from "./TemplateBookBookingPaymentSelection.vue?vue&type=script&lang=js"

import "./TemplateBookBookingPaymentSelection.vue?vue&type=style&index=0&id=f37b1108&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f37b1108"

export default script